import { useMemo } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Checkbox } from "@/components/ui/checkbox";
import { preview } from "@/lib/fieldCodec";

const PREFERRED = ["name", "full_name", "title", "status", "role", "phone", "email", "city", "lead_code", "category_name", "created_at", "updated_at"];

// Column set = most frequent keys across loaded docs, preferred keys first.
const pickColumns = (rows) => {
  const freq = {};
  rows.forEach((r) => Object.keys(r).forEach((k) => { if (k !== "id") freq[k] = (freq[k] || 0) + 1; }));
  const keys = Object.keys(freq).sort((a, b) => {
    const pa = PREFERRED.indexOf(a), pb = PREFERRED.indexOf(b);
    if (pa !== -1 || pb !== -1) return (pa === -1 ? 99 : pa) - (pb === -1 ? 99 : pb);
    return freq[b] - freq[a];
  });
  return { cols: keys.slice(0, 6), total: keys.length };
};

export function DocTable({ rows, onOpen, selected, onToggle, onToggleAll }) {
  const { cols, total } = useMemo(() => pickColumns(rows), [rows]);
  const sel = selected || new Set();
  const allOn = rows.length > 0 && rows.every((r) => sel.has(r.id));
  return (
    <div className="overflow-x-auto">
      <Table data-testid="doc-table">
        <TableHeader><TableRow>
          {onToggle && <TableHead className="w-8"><Checkbox checked={allOn} onCheckedChange={() => onToggleAll(!allOn)} data-testid="select-all-shown" /></TableHead>}
          <TableHead className="font-mono text-[11px]">id</TableHead>
          {cols.map((c) => <TableHead key={c} className="font-mono text-[11px]">{c}</TableHead>)}
          <TableHead className="text-[11px] text-right">{total} keys</TableHead>
        </TableRow></TableHeader>
        <TableBody>
          {rows.map((r) => (
            <TableRow key={r.id} className={`cursor-pointer hover:bg-accent/40 ${sel.has(r.id) ? "bg-primary/5" : ""}`} onClick={() => onOpen(r.id)} data-testid={`doc-row-${r.id}`}>
              {onToggle && <TableCell onClick={(e) => e.stopPropagation()}><Checkbox checked={sel.has(r.id)} onCheckedChange={() => onToggle(r.id)} data-testid={`select-row-${r.id}`} /></TableCell>}
              <TableCell className="font-mono text-[11px] text-primary whitespace-nowrap">{r.id}</TableCell>
              {cols.map((c) => <TableCell key={c} className="text-xs max-w-[220px] truncate">{r[c] === undefined ? <span className="text-muted-foreground">—</span> : preview(r[c], 40)}</TableCell>)}
              <TableCell className="text-right text-[11px] font-mono text-muted-foreground">{Object.keys(r).length - 1}</TableCell>
            </TableRow>
          ))}
          {rows.length === 0 && <TableRow><TableCell colSpan={cols.length + 3} className="text-center py-10 text-muted-foreground text-sm">No documents.</TableCell></TableRow>}
        </TableBody>
      </Table>
    </div>
  );
}
